import { render, staticRenderFns } from "./AddEditRequirements.vue?vue&type=template&id=282c4a1a"
import script from "./AddEditRequirements.vue?vue&type=script&lang=js"
export * from "./AddEditRequirements.vue?vue&type=script&lang=js"
import style0 from "./AddEditRequirements.vue?vue&type=style&index=0&id=282c4a1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports